import { useState } from 'react';
import { useForm } from 'react-hook-form';

import { NonSsoSignInMethod, useUrlQueryParam } from '@neo.tax/shared';

import { EmailAndPasswordForm } from './EmailAndPasswordForm';
import { EmailLinkForm } from './EmailLinkForm';
import { LoginFormValues } from './login-form.types';

export const LoginForm = (): React.ReactElement => {
  const [nonSsoSignInMethod, setNonSsoSignInMethod] = useState<NonSsoSignInMethod | null>(null);

  // Pre-populate the email when arriving from an invite link or a post-verification redirect
  // (?prefillEmail=…). Editable — this only seeds the field's default value.
  const prefillEmail = useUrlQueryParam('prefillEmail');
  const { control, formState, handleSubmit, watch } = useForm<LoginFormValues>({
    mode: 'onChange',
    defaultValues: {
      email: prefillEmail ?? '',
      password: '',
    },
  });
  if (nonSsoSignInMethod === NonSsoSignInMethod.EMAIL_LINK) {
    return <EmailLinkForm control={control} formState={formState} handleSubmit={handleSubmit} watch={watch} />;
  }

  return (
    <EmailAndPasswordForm
      control={control}
      formState={formState}
      handleSubmit={handleSubmit}
      setNonSsoSignInMethod={setNonSsoSignInMethod}
      watch={watch}
    />
  );
};
